import React, { useState, useContext } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { Button, List, ListItem, ListItemText, makeStyles, Typography, useTheme } from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'
import useMuseStyles from '../../themes/useMuseStyles'
import clsx from 'clsx'
import { UserContext, UserContextType } from '../../UserContext'
import { CommunityMessagesPageMode } from './CommunityMessagesPage'
import { useCommunityFeature } from '../../services/useCommunityFeature'
import CommunityChatbox from './CommunityChatbox'
import { ChatMessage } from '../../types/ChatContracts'
import UserSelectorAutoComplete from './UserSelectorAutoComplete'
import { AppContext, AppContextType } from '../../AppContext'

const borderColor = '#3F3F3F'

const useStyles = makeStyles((theme) => ({
    newMessageNav: {
        backgroundColor: '#f9cc04',

        '& .MuiListItemText-primary': {
            color: '#111',
            fontWeight: '600',
        },
    },
}))
export const useStyles_CommunityMessagesNewMessageGroupPage = useStyles

function CommunityMessagesNewMessageGroupPage({
    setPage,
    communityFeature,
}: {
    setPage: React.Dispatch<React.SetStateAction<CommunityMessagesPageMode>>
    communityFeature: ReturnType<typeof useCommunityFeature>
}) {
    const gclasses = useMuseStyles(useTheme())
    const styles = useStyles(useTheme())

    const { dispatch: appDispatch } = useContext(AppContext) as AppContextType
    const { state, dispatch } = useContext(UserContext) as UserContextType

    const [selectedCollaboratorIds, set_selectedCollaboratorIds] = useState<string[]>([])

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '8px' }}>
                <div
                    style={{
                        display: 'flex',
                        width: 'fit-content',
                        flexDirection: 'column',
                        alignItems: 'center',
                        marginBottom: 8,
                    }}
                >
                    <Button
                        variant="outlined"
                        color="primary"
                        style={{ marginTop: '5px', width: 40, height: 40 }}
                        className={clsx(gclasses.circleButton, gclasses.buttonSmall, gclasses.buttonSvgIconSmall)}
                        classes={{
                            label: gclasses.primaryColor,
                            disabled: gclasses.circleButtonDisabled,
                        }}
                        onClick={() => setPage('chat')}
                    >
                        <CancelIcon />
                    </Button>
                    <Typography variant="body1" className={gclasses.textSmaller} style={{ marginTop: 5 }}>
                        Cancel
                    </Typography>
                </div>
            </div>
            <div style={{ borderTop: 'solid 1px ' + borderColor, display: 'flex', flexGrow: 2 }}>
                <div
                    id="messages-panel-left"
                    style={{ borderRight: 'solid 1px ' + borderColor, width: 220, maxHeight: 560, overflowY: 'auto' }}
                >
                    <List className={gclasses.navMenu2} component="nav">
                        <ListItem className={clsx(styles.newMessageNav)} onClick={() => {}}>
                            <ListItemText primary={'New Message'} />
                        </ListItem>
                    </List>
                </div>
                <div id="messages-panel-right" style={{ flexGrow: 2, display: 'flex', flexDirection: 'column' }}>
                    <div id="message-message-pane" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <div style={{ height: 40 }}>
                            <UserSelectorAutoComplete
                                communityFeature={communityFeature}
                                onSelectionChanged={(userUrns) => {
                                    set_selectedCollaboratorIds(userUrns)
                                }}
                                userUrns={selectedCollaboratorIds}
                            />
                        </div>
                        {state.userUrn && (
                            <div style={{ flexGrow: 2 }}>
                                <CommunityChatbox
                                    userUrn={state.userUrn}
                                    groupUrn={''}
                                    isEmpty
                                    EmptyMessagesComponent={
                                        <div
                                            style={{
                                                display: 'flex',
                                                height: '100%',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Typography variant="body1">
                                                Send a message to create the conversation!
                                            </Typography>
                                        </div>
                                    }
                                    onSendMessage={(message: string) => {
                                        if (selectedCollaboratorIds.length > 0) {
                                            // Create message group with initial message as 'message'.
                                            // Then, show CommunityMessagesChatPage with the newly created message group
                                            // selected.
                                            const chatmsg: ChatMessage = {
                                                id: uuidv4(),
                                                timestamp: new Date(),
                                                senderUrn: state.userUrn,
                                                recipientUrns: [],
                                                contentType: 'text',
                                                body: message,
                                            }
                                            communityFeature
                                                .createNewMessageGroup(selectedCollaboratorIds, chatmsg)
                                                .then(() => {
                                                    setPage('chat')
                                                })
                                        } else {
                                            appDispatch({
                                                type: 'root_snackbar_history_append',
                                                value: {
                                                    severity: 'info',
                                                    message: `Please specify the users to send the message to.`,
                                                },
                                            })
                                        }
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CommunityMessagesNewMessageGroupPage
